import styled from 'styled-components'

export const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 9.3vw;
    @media only screen and (max-width: 900px) {
        font-size: 16vw;
    }
    &.mobileVersion {
        font-size: 16vw;
    }
`;

export const LogoNormal = styled.div`
    font-family: LSCCondensed;
`;

export const LogoItalic = styled.div`
    font-family: LSCCondensed;
    font-style: italic;
    margin-right: 2vw;
`;